import DatePopover from './DatePopover'

export default DatePopover



// WEBPACK FOOTER //
// ./src/legacy/containers/Popovers/DatePopover/index.js